var map = {
	"./australian-restaurants_01.jpg": 8271,
	"./australian-tourism_01.jpg": 8736,
	"./before-the-tour_01.jpg": 353,
	"./boeing_01.jpg": 1426,
	"./boston-ivy_01.jpg": 4268,
	"./brian-lock-music_01.jpg": 4705,
	"./cascades_01.jpg": 769,
	"./centtrip_01.jpg": 7818,
	"./direct-line_01.jpg": 2873,
	"./everest_01.jpg": 6219,
	"./evolution-of-music_01.jpg": 8222,
	"./expert-women-project_01.jpg": 3919,
	"./fury-cs_01.jpg": 1006,
	"./hyperlathe_01.jpg": 48,
	"./invenias_01.jpg": 9900,
	"./ireland-tourism_01.jpg": 2943,
	"./kino-design_01.jpg": 2798,
	"./lebara_01.jpg": 1971,
	"./mccann_01.jpg": 5474,
	"./mission-housing_01.jpg": 2227,
	"./payment-card-solutions_01.jpg": 3740,
	"./princess-cruises_01.jpg": 926,
	"./simplestream_01.jpg": 5318,
	"./singapore-airlines_01.jpg": 9730,
	"./soapy-business_01.jpg": 6384,
	"./the-mercy_01.jpg": 1908,
	"./treasure8_01.jpg": 2111,
	"./yorkshire-bank_01.jpg": 1148
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1761;